/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleLeftIcon32Regular = forwardRef('ArrowFigureACircleLeftIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M23 16a1 1 0 0 0-1-1H11.59l3.308-3.308a1 1 0 1 0-1.414-1.414l-3.6 3.6a2.99 2.99 0 0 0-.877 2.002 1.012 1.012 0 0 0 0 .24 2.99 2.99 0 0 0 .876 2.001l3.601 3.601a1 1 0 0 0 1.414-1.414L11.591 17H22a1 1 0 0 0 1-1Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29 16c0-7.18-5.82-13-13-13S3 8.82 3 16s5.82 13 13 13 13-5.82 13-13ZM16 5c6.075 0 11 4.925 11 11s-4.925 11-11 11S5 22.075 5 16 9.925 5 16 5Z" })));
});
